module.exports = __webpack_public_path__ + "img/af318d7.png";